/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-natural-join-visualizer-fr block)");
/* eslint-enable no-console */

(function () {
    const datasets = {
        productsCategories: {
            leftName: "produits", rightName: "categories",
            leftRows: [
                { categorie_id: 1, nom: "Stylo", prix: 2.5 },
                { categorie_id: 2, nom: "Cahier", prix: 4.0 },
                { categorie_id: 1, nom: "Crayon", prix: 0.8 },
                { categorie_id: 3, nom: "Calculette", prix: 15.0 }
            ],
            rightRows: [
                { categorie_id: 1, libelle: "Papeterie" },
                { categorie_id: 2, libelle: "Fournitures" },
                { categorie_id: 4, libelle: "Informatique" }
            ]
        },
        employeesDepartments: {
            leftName: "employes", rightName: "departements",
            leftRows: [
                { dept_id: 10, nom: "Emma", poste: "Dev" },
                { dept_id: 20, nom: "Liam", poste: "Designer" },
                { dept_id: 30, nom: "Noah", poste: "Manager" },
                { dept_id: 99, nom: "Olivia", poste: "Analyst" }
            ],
            rightRows: [
                { dept_id: 10, departement: "Ventes" },
                { dept_id: 20, departement: "Marketing" },
                { dept_id: 40, departement: "Finance" }
            ]
        },
        productsStock: {
            leftName: "produits", rightName: "stock",
            leftRows: [
                { code: "A1", libelle: "Stylo", prix: 2.5 },
                { code: "A2", libelle: "Cahier", prix: 4.0 },
                { code: "A3", libelle: "Règle", prix: 1.5 },
                { code: "A4", libelle: "Crayon", prix: 0.8 }
            ],
            rightRows: [
                { code: "A1", quantite: 100 },
                { code: "A2", quantite: 50 },
                { code: "A5", quantite: 30 }
            ]
        }
    };

    // — Éléments DOM —
    const datasetEl = document.getElementById("njDataset");
    const tableAWrap = document.getElementById("njTableAWrap");
    const tableBWrap = document.getElementById("njTableBWrap");
    const resultWrap = document.getElementById("njResultWrap");
    const resultMeta = document.getElementById("njResultMeta");
    const sqlCode = document.getElementById("njSqlCode");
    const joinExpl = document.getElementById("njJoinExplanation");
    const tableATitle = document.getElementById("njTableATitle");
    const tableBTitle = document.getElementById("njTableBTitle");
    const warning = document.getElementById("njWarning");
    const pairsWrap = document.getElementById("njPairsWrap");
    const labelA = document.getElementById("njLabelA");
    const labelB = document.getElementById("njLabelB");
    const colsLeft = document.getElementById("njColsLeft");
    const colsCenter = document.getElementById("njColsCenter");
    const colsRight = document.getElementById("njColsRight");
    const svgNoteL1 = document.getElementById("njSvgNoteL1");
    const svgNoteL2 = document.getElementById("njSvgNoteL2");

    const toggleTableA = document.getElementById("toggleNjTableA");
    const toggleTableB = document.getElementById("toggleNjTableB");
    const toggleDiagram = document.getElementById("toggleNjDiagram");
    const togglePairs = document.getElementById("toggleNjPairs");
    const toggleResult = document.getElementById("toggleNjResult");
    const toggleSql = document.getElementById("toggleNjSql");

    const panelTableA = document.getElementById("njPanelTableA");
    const panelTableB = document.getElementById("njPanelTableB");
    const sectionTables = document.getElementById("njSectionTables");
    const diagramWrap = document.getElementById("njDiagramWrap");
    const panelPairs = document.getElementById("njPanelPairs");
    const blockSql = document.getElementById("njBlockSql");
    const blockResult = document.getElementById("njBlockResult");
    const divider = document.getElementById("njDivider");

    // — Utilitaires —
    function getColumns(rows) {
        const cols = new Set();
        rows.forEach(r => Object.keys(r).forEach(k => cols.add(k)));
        return [...cols];
    }

    function escapeHtml(v) {
        return String(v ?? "")
            .replace(/&/g, "&amp;").replace(/</g, "&lt;")
            .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    function getCommonCols(leftRows, rightRows) {
        const lCols = new Set(getColumns(leftRows));
        return getColumns(rightRows).filter(c => lCols.has(c));
    }

    // — Diagramme SVG —
    function setColTspans(el, cols, x, fillColor) {
        if (!cols.length) {
            el.innerHTML = `<tspan x="${x}" y="160" fill="#aaa">—</tspan>`;
            return;
        }
        const startY = 160 - ((cols.length - 1) * 18) / 2;
        el.innerHTML = cols.map((c, i) =>
            `<tspan x="${x}" ${i === 0 ? `y="${startY}"` : `dy="18"`} fill="${fillColor}">${escapeHtml(c)}</tspan>`
        ).join("");
    }

    function renderDiagram(leftRows, rightRows, commonCols) {
        const data = datasets[datasetEl.value];
        const lOnly = getColumns(leftRows).filter(c => !commonCols.includes(c));
        const rOnly = getColumns(rightRows).filter(c => !commonCols.includes(c));

        labelA.textContent = data.leftName;
        labelB.textContent = data.rightName;

        setColTspans(colsLeft, lOnly, 175, "#333");
        setColTspans(colsCenter, commonCols, 300, "#0a4a9e");
        setColTspans(colsRight, rOnly, 425, "#333");

        const note = commonCols.length
            ? `Jointure automatique sur : ${commonCols.join(", ")}`
            : "Aucune colonne commune détectée !";
        const words = note.split(" ");
        const mid = Math.ceil(words.length / 2);
        svgNoteL1.textContent = words.slice(0, mid).join(" ");
        svgNoteL2.textContent = words.slice(mid).join(" ");
    }

    // — Tables —
    function renderTable(container, rows, commonCols, { matchedIdx = new Set(), unmatchedIdx = new Set() } = {}) {
        if (!rows.length) { container.innerHTML = '<div class="nj-empty">Aucune ligne.</div>'; return; }
        const cols = getColumns(rows);
        let html = "<table><thead><tr>"
            + cols.map(c => `<th class="${commonCols.includes(c) ? "nj-common-col" : ""}">${escapeHtml(c)}</th>`).join("")
            + "</tr></thead><tbody>";
        rows.forEach((row, i) => {
            const cls = matchedIdx.has(i) ? "nj-match" : unmatchedIdx.has(i) ? "nj-nomatch" : "";
            html += `<tr class="${cls}">` + cols.map(c => `<td>${escapeHtml(row[c] ?? "NULL")}</td>`).join("") + "</tr>";
        });
        html += "</tbody></table>";
        container.innerHTML = html;
    }

    // — Calcul jointure —
    function computeNaturalJoin(data) {
        const { leftRows, rightRows } = data;
        const commonCols = getCommonCols(leftRows, rightRows);
        const lCols = getColumns(leftRows);
        const rOnlyCols = getColumns(rightRows).filter(c => !commonCols.includes(c));
        const leftHasMatch = new Set();
        const rightHasMatch = new Set();
        const pairs = [], result = [];

        if (commonCols.length) {
            leftRows.forEach((lr, li) => {
                rightRows.forEach((rr, ri) => {
                    if (commonCols.every(c => lr[c] === rr[c])) {
                        leftHasMatch.add(li);
                        rightHasMatch.add(ri);
                        pairs.push({ leftRow: lr, rightRow: rr });
                        const row = {};
                        lCols.forEach(c => row[c] = lr[c] ?? null);
                        rOnlyCols.forEach(c => row["B." + c] = rr[c] ?? null);
                        result.push(row);
                    }
                });
            });
        }

        return { commonCols, leftHasMatch, rightHasMatch, pairs, result };
    }

    // — Résultat —
    function renderResult(rows) {
        if (!rows.length) { resultWrap.innerHTML = '<div class="nj-empty">Aucune ligne résultante.</div>'; return; }
        const cols = getColumns(rows);
        let html = "<table><thead><tr>" + cols.map(c => `<th>${escapeHtml(c)}</th>`).join("") + "</tr></thead><tbody>";
        rows.forEach(row => {
            html += "<tr>" + cols.map(c => `<td>${escapeHtml(row[c] ?? "NULL")}</td>`).join("") + "</tr>";
        });
        html += "</tbody></table>";
        resultWrap.innerHTML = html;
    }

    // — Paires —
    function renderPairs(pairs, data) {
        if (!pairs.length) {
            pairsWrap.innerHTML = '<div class="nj-empty">Aucune paire correspondante.</div>';
            return;
        }
        pairsWrap.innerHTML = '<div class="nj-pairs">' + pairs.map(pair => `
            <div class="nj-pair-card">
                <div class="nj-badge">Correspondance</div>
                <div class="nj-pair-grid">
                    <div class="nj-mini-box"><strong>${escapeHtml(data.leftName)}</strong><pre>${escapeHtml(JSON.stringify(pair.leftRow, null, 2))}</pre></div>
                    <div class="nj-arrow">↔</div>
                    <div class="nj-mini-box"><strong>${escapeHtml(data.rightName)}</strong><pre>${escapeHtml(JSON.stringify(pair.rightRow, null, 2))}</pre></div>
                </div>
            </div>`).join("") + "</div>";
    }

    // — Visibilité —
    function updateVisibility() {
        const showSql = toggleSql.checked;
        const showResult = toggleResult.checked;
        const showA = toggleTableA.checked;
        const showB = toggleTableB.checked;

        blockSql.classList.toggle("nj-hidden", !showSql);
        blockResult.classList.toggle("nj-hidden", !showResult);
        divider.classList.toggle("nj-hidden", !showSql && !showResult);
        panelTableA.classList.toggle("nj-hidden", !showA);
        panelTableB.classList.toggle("nj-hidden", !showB);
        sectionTables.classList.toggle("nj-hidden", !showA && !showB);
        diagramWrap.classList.toggle("nj-hidden", !toggleDiagram.checked);
        panelPairs.classList.toggle("nj-hidden", !togglePairs.checked);
    }

    // — Rendu principal —
    function renderAll() {
        const data = datasets[datasetEl.value];
        const { leftName, rightName, leftRows, rightRows } = data;
        const { commonCols, leftHasMatch, rightHasMatch, pairs, result } = computeNaturalJoin(data);

        tableATitle.textContent = "Table A — " + leftName;
        tableBTitle.textContent = "Table B — " + rightName;

        const allLeft = new Set(leftRows.map((_, i) => i));
        const allRight = new Set(rightRows.map((_, i) => i));
        const notLeft = new Set([...allLeft].filter(i => !leftHasMatch.has(i)));
        const notRight = new Set([...allRight].filter(i => !rightHasMatch.has(i)));

        renderDiagram(leftRows, rightRows, commonCols);
        renderTable(tableAWrap, leftRows, commonCols, { matchedIdx: leftHasMatch, unmatchedIdx: notLeft });
        renderTable(tableBWrap, rightRows, commonCols, { matchedIdx: rightHasMatch, unmatchedIdx: notRight });
        renderResult(result);
        renderPairs(pairs, data);

        warning.textContent = commonCols.length ? "" : "⚠️ Aucune colonne commune détectée. Le NATURAL JOIN se comportera comme un CROSS JOIN.";
        warning.classList.toggle("nj-hidden", !!commonCols.length);

        sqlCode.textContent = `SELECT *\nFROM ${leftName}\nNATURAL JOIN ${rightName};`;

        joinExpl.textContent = commonCols.length
            ? `Jointure automatique sur : ${commonCols.join(", ")}. Aucune clause ON requise.`
            : "Aucune colonne commune — résultat équivalent à un CROSS JOIN.";

        resultMeta.textContent = `NATURAL JOIN entre ${leftName} et ${rightName} sur [${commonCols.join(", ") || "—"}] — ${result.length} ligne(s) résultante(s).`;

        updateVisibility();
    }

    // — Événements —
    [toggleTableA, toggleTableB, toggleDiagram, togglePairs, toggleResult, toggleSql]
        .forEach(el => el.addEventListener("change", updateVisibility));
    datasetEl.addEventListener("change", renderAll);
    document.getElementById("njReloadBtn").addEventListener("click", renderAll);

    document.getElementById("njShareBtn").addEventListener("click", () => {
        const url = window.location.href;
        if (navigator.share) {
            navigator.share({ title: "Visualiseur NATURAL JOIN SQL", url }).catch(() => { });
        } else {
            navigator.clipboard.writeText(url).then(() => {
                const toast = document.getElementById("njShareToast");
                toast.style.display = "block";
                setTimeout(() => { toast.style.display = "none"; }, 2500);
            }).catch(() => { prompt("Copiez ce lien :", url); });
        }
    });

    renderAll();
})()